// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__HI_CW","row":"ProcedureTreatmentSummary_row__3JKgo"};